import {
  Badge,
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  Typography,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from '@mui/material';
import { TextForm } from '../../../components/TextBox';
import TextPhone from '../../../components/TextBox/TextPhone';
import SelectForm from '../../../components/SelectBox/SelectForm';
import AutocompleteMultiForm from '../../../components/SelectBox/AutocompleteMultiForm';
import AutocompleteTextForm from '../../../components/TextBox/AutocompleteTextForm';
import { CloudDownload, Save } from '@mui/icons-material';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { useGetSupplierQuery, useSubmitSupplierMutation } from '../../../store/api/supplierEvaluationApi';
import { usePostVendorByTaxMutation } from '../../../store/api/vendorApi';
import { usePostUserSendToApproveMutation } from '../../../store/api/userApi';
import { useNavigate } from 'react-router-dom';
import CompanyLogoAttachment from '../CompanyInformationSup/CompanyLogoAttachment';
import IndividualNda from './IndividualNda';
import IndividualEthics from './IndividualEthics';
import IndividualBank from './IndividiualBank';
import { showErrorToast, showSuccessToast, showWarningToast } from '../../../constToast/constToast';
import { LoadingButton } from '@mui/lab';

const IndividualVendor = () => {
  const { t } = useTranslation('supplier')
  const { data } = useGetSupplierQuery(0);
  const [nda, setNda] = useState([])
  const [ethics, setEthics] = useState([])
  const [bankList, setBankList] = useState([])
  const [loadingSubmit, setLoadingSubmit] = useState(false)

  const { handleSubmit, form, control, reset, formState: { errors, isValid }, setValue, watch } = useForm({ mode: 'onBlur' });

  const filteredBusinessCategoriesIds = watch('businessCategories')?.map(x => x.id)
  const filteredProductServices = data?.data?.services?.filter(item => filteredBusinessCategoriesIds?.includes(item.businessCategoryId));
  const [openAttachmentDialog, setOpenAttachmentDialog] = useState(false)
  const [companyLogo, setCompanyLogo] = useState([])

  const [submitMutation] = useSubmitSupplierMutation();
  const onSubmit = async (data) => {

    // NDA check
    if (!Array.isArray(nda) || nda.length === 0 || nda[0]?.isAgreed !== true) {
      showWarningToast('NDA is not selected')
      return
    }

    // Ethics check
    if (!Array.isArray(ethics) || ethics.length === 0 || ethics[0]?.isAgreed !== true) {
      showWarningToast('Ethics is not selected')
      return
    }

    const saveData = await submitMutation({
     companyInformation: {
        ...data,
        vendorId: 0
      },
      nonDisclosureAgreement: nda,
      codeOfBuConduct: ethics,
      bankAccounts: bankList,
      dueDiligence: [],
      isRevise: false,
      isSubmitted: true
    });


    if (saveData?.data?.statusCode === 200) {
      showSuccessToast(`Succesfully submitted Vendor Code: ${saveData?.data?.data?.companyInformation?.vendorCode}`)
      setLoadingSubmit(false)
      navigate(`/waiting`)
      window.location.reload();
    } else if (saveData?.error?.status === 422) {
      showWarningToast(saveData?.error?.data?.errors)
    } else {
      showErrorToast('Error')
      setLoadingSubmit(false)
    }

  }

  const [postVendorByTax] = usePostVendorByTaxMutation();
  const [taxDialog, setTaxDialog] = useState(false)

  const handleTaxBlur = async (value) => {
    const data = await postVendorByTax(value);
    if (data?.data?.vendorId !== 0) {
      setTaxDialog(true)
    }
  };
  const handleTaxCloseDialog = () => {
    setTaxDialog(false);
    setValue('taxId', '')
  }

  const [postTax] = usePostUserSendToApproveMutation();
  const navigate = useNavigate();
  const handleYesTax = () => {
    postTax();
    navigate('/waiting')
  }


  let xlColumn, lgColumn, mdColumn, smColumn, xsColumn;

  //Column
  xlColumn = 3;
  lgColumn = 3;
  mdColumn = 4;
  smColumn = 6;
  xsColumn = 12;

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: 'linear-gradient(135deg, #f5f7fa, #e8eef7)',
        px: 2
      }}
    >
      <Card
        sx={{
          width: '100%',
          maxWidth: 1200,
          borderRadius: 3,
          boxShadow: '0 15px 40px rgba(0,0,0,0.12)'
        }}
      >
        <CardContent
          sx={{
            maxHeight: '85vh',
            overflowY: 'auto',
            p: { xs: 2, sm: 4 }
          }}
        >
          {/* Başlıq (istəsən saxlaya da bilərsən) */}
          <Box sx={{ display: 'flex', alignContent: 'center', gap: 2 }}>
            <div>
              <Typography variant="h4" fontWeight={600} mb={3}>
                Individual Vendor
              </Typography>
            </div>

            <div>
              {/* <Button size='small' onClick={handleSubmit(onSubmit)} variant='contained' color='success' endIcon={<Save />}>{t('save')}</Button> */}

              <LoadingButton
                endIcon={<Save />}
                size='small'
                color='success'
                loading={loadingSubmit}
                variant="contained"
                onClick={handleSubmit(onSubmit)}
              >
                {t('save')}
              </LoadingButton>
            </div>
          </Box>

          <form onSubmit={handleSubmit(onSubmit)} noValidate>
            <Grid
              container
              spacing={2}
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Grid container spacing={2} display='flex' justifyContent='space-between' alignItems='center'>
                <Grid item xs={12}>
                  <Divider />
                </Grid>

                <Grid item xs={xsColumn} sm={smColumn} md={mdColumn} lg={lgColumn} xl={xlColumn}>
                  <TextForm label={t('email')} dynamicField='email'
                    control={control} errors={errors}
                    required={true}
                  />
                </Grid>

                <Grid item xs={xsColumn} sm={smColumn} md={mdColumn} lg={lgColumn} xl={xlColumn}>
                  <TextForm label={t('full_name')} dynamicField='contactPerson'
                    control={control} errors={errors}
                    required={true}
                    min={3} max={40}
                  />
                </Grid>

                <Grid item xs={xsColumn} sm={smColumn} md={mdColumn} lg={lgColumn} xl={xlColumn}>
                  <TextPhone
                    control={control}
                    dynamicField="phoneNo"
                    label={t('contact_phone')}
                    required={true}
                    errors={errors}
                    minDigits={12}
                  />
                </Grid>
                <Grid item xs={xsColumn} sm={smColumn} md={mdColumn} lg={lgColumn} xl={xlColumn}>
                  <TextForm label={t('company_legal_name')} dynamicField='companyName'
                    control={control} errors={errors}
                    required={false}
                    min={3} max={40}
                  />
                </Grid>
                <Grid item xs={xsColumn} sm={smColumn} md={mdColumn} lg={lgColumn} xl={xlColumn}>
                  <TextForm label={t('taxId')} dynamicField='taxId'
                    control={control} errors={errors}
                    required={true}
                    min={3} max={40}
                    disabled={false}
                    onBlur={(e) => handleTaxBlur(e.target.value)}
                  />
                </Grid>

                <Grid item xs={xsColumn} sm={smColumn} md={mdColumn} lg={lgColumn} xl={xlColumn}>
                  <TextForm label={t('address')} dynamicField='companyAdress'
                    control={control} errors={errors}
                    required={false}
                    min={3} max={90}
                  />
                </Grid>
                <Grid item xs={xsColumn} sm={smColumn} md={mdColumn} lg={lgColumn} xl={xlColumn}>
                  <SelectForm label={t('country')} id='countryCode' name='countryName'
                    control={control} errors={errors} disabled={false}
                    data={data?.data?.countries} dynamicField='country' required={false} />
                </Grid>
                <Grid item xs={xsColumn} sm={smColumn} md={mdColumn} lg={lgColumn} xl={xlColumn}>
                  <TextForm label={t('city')} dynamicField='city'
                    control={control} errors={errors}
                    required={false}
                    min={3} max={40}
                  />
                </Grid>
                <Grid item xs={xsColumn} sm={smColumn} md={mdColumn} lg={lgColumn} xl={xlColumn}>
                  <TextForm label={t('website')} dynamicField='webSite'
                    control={control} errors={errors}
                    required={false}
                    min={3} max={40}
                  />
                </Grid>


                <Grid item xs={12} sm={5.67}>
                  <AutocompleteMultiForm data={data?.data?.businessCategories} errors={errors}
                    label={t('business_categories')} dynamicField='businessCategories' name='name' id='id'
                    control={control} required={true}
                    onChange={e => {
                      setValue('businessCategories', e)
                      setValue('services', watch('services')?.filter(service => e?.some(category => category.id === service.businessCategoryId)))
                    }} />
                </Grid>

                {watch('services')?.some(item => item.id === 43) ?
                  <Grid item xs={12} sm={5.67}>
                    <TextForm label={t('other')} dynamicField='other'
                      control={control} errors={errors}
                      required={true}
                    />
                  </Grid> : <></>}

                <Grid item xs={12} sm={5.67}>
                  <AutocompleteTextForm control={control} dynamicField='representedProducts'
                    errors={errors} required={false} label={t('represented_products')} />
                </Grid>

                <Grid item xs={12} sm={5.67}>
                  <AutocompleteMultiForm data={filteredProductServices} errors={errors}
                    label={t('products')} dynamicField='services' name='name' id='id'
                    control={control} required={true} />
                </Grid>


                <Grid item xs={12} sm={5.67}>
                  <AutocompleteTextForm control={control} dynamicField='representedCompanies'
                    errors={errors} required={false} label={t('represented_companies')} />
                </Grid>

                <Grid item xs={12} sm={5.67}>
                  <Box display='flex' alignItems='center' justifyContent='space-between'>
                    <Box display='flex' alignItems='center' >
                      <Typography mr={1}>{t('company_logo')}</Typography>
                      <Badge badgeContent={companyLogo?.filter((x) => x.type === 0)?.length} color="error">
                        <Button size='small' onClick={() => setOpenAttachmentDialog(true)} variant='contained' endIcon={
                          <CloudDownload />
                        }>{t('attachments')}</Button>
                      </Badge>
                    </Box>

                    <Box display='flex' alignItems='center' >
                      <IndividualNda nda={nda} setNda={setNda} />
                    </Box>

                    <Box display='flex' alignItems='center' >
                      <IndividualEthics nda={nda} ethics={ethics} setEthics={setEthics} disabled={!nda?.[0]?.isAgreed == true} />
                    </Box>
                  </Box>

                </Grid>
              </Grid >
            </Grid>

          </form>

          <Grid item xs={12} mt={4} mb={4}>
            <Divider />
          </Grid>
          <IndividualBank tableData={bankList} setTableData={setBankList} />
        </CardContent>
      </Card>


      <CompanyLogoAttachment
        nameKey='companyLogo'
        open={openAttachmentDialog}
        setOpen={setOpenAttachmentDialog}
        module={'Vendors'}
        value={companyLogo}
        setValue={setCompanyLogo}
        initialData={companyLogo}
      />


      <div>
        <Dialog open={taxDialog}>
          <DialogTitle>{t('taxModalTitle1')}</DialogTitle>
          <Divider />
          <DialogContent>
            <Box>
              {t('taxModalTitle2')}
            </Box>
          </DialogContent>
          <DialogActions>
            <Button variant='contained' onClick={handleYesTax}>
              {t('yes')}
            </Button>
            <Button variant="outlined" onClick={handleTaxCloseDialog} sx={{ color: 'gray', borderColor: '#D3D3D3' }}>
              {t('cancel')}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </Box>
  );
};

export default IndividualVendor;
